import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AuthSelectors, ClientOptionsDispatchers, SessionSelectors } from '@store';
import { switchMap } from 'rxjs/operators';
import { StatistikService } from 'app/statistik/statistik.service';

@Component({
    selector: 'app-statistik-tilafgang',
    template: `
        <app-statistik-tilafgang-ui
            [nyeKunder]="nyeKunder$ | async"
            [mistedeKunder]="mistedeKunder$ | async"
            [periode]="periode$ | async"
            [laCards]="laCards$ | async"
            [kaCards]="kaCards$ | async"
            [saCards]="saCards$ | async"
            [user]="user$ | async"
            [laID]="la$ | async"
            [kaID]="ka$ | async"
            [saID]="sa$ | async"
            (periodeChange)="periodeChange($event)"
            (laChange)="laSubject.next($event)"
            (kaChange)="kaSubject.next($event)"
            (saChange)="saSubject.next($event)"

        ></app-statistik-tilafgang-ui>
    `,
    styleUrl: './statistik-tilafgang.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StatistikTilafgangContainerComponent {
    periodeSubject = new BehaviorSubject<{ fra: string, til: string }>({fra: null, til: null});
    periode$ = this.periodeSubject.asObservable();
    laSubject = new BehaviorSubject<number>(null);
    la$ = this.laSubject.asObservable();
    kaSubject = new BehaviorSubject<number>(null);
    ka$ = this.kaSubject.asObservable();
    saSubject = new BehaviorSubject<number>(null);
    sa$ = this.saSubject.asObservable();

    laCards$ = this.periode$.pipe(switchMap(periode => this.sessionSelector.usersLA$(new Date(periode.fra))));
    kaCards$ = this.periode$.pipe(switchMap(periode => this.sessionSelector.usersKA$(new Date(periode.fra))));
    saCards$ = this.periode$.pipe(switchMap(periode => this.sessionSelector.usersSA$(new Date(periode.fra))));
    user$ = this.authSelector.user$;

    nyeKunder$ = this.periode$.pipe(switchMap(periode => this.statistikService.getTilafgangNye(periode)));
    mistedeKunder$ = this.periode$.pipe(switchMap(periode => this.statistikService.getTilafgangMistede(periode)));

    periodeChange(periode: { fra: string; til: string }) {
        this.periodeSubject.next(periode);
    }

    constructor(
        private sessionSelector: SessionSelectors,
        private clientsOptionsDispatch: ClientOptionsDispatchers,
        private authSelector: AuthSelectors,
        private statistikService: StatistikService
    ) {
        this.clientsOptionsDispatch.loadClientOptions();
    }
}
